import { View } from "binder"
import { ProductHuntViewModel } from "./productHunt-viewModel"

export class ProductHuntView extends View<ProductHuntViewModel>{
    GetViewUniqueId(): string {
        return "V-61864B73-4C39-4DEE-8056-D74BE0402EF1"
    }
    loadHtml(): string {
        let element = require('./productHunt.html').default;
        let style = require('./productHunt.less');
        return element;
    }
    constructor() {
       super();
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set from(v: moment.Moment) { this._from = v; } public get from(): moment.Moment { return this._from;} private _from: moment.Moment;
    public set until(v: moment.Moment) { this._until = v; } public get until(): moment.Moment { return this._until;} private _until: moment.Moment;
    download(){
        this.dataContext.download();
    }
}
